import { LoaderCircle } from 'lucide-react';

import { cn } from '../lib/cn';

export function Spinner({ className }: { className?: string }) {
  return (
    <LoaderCircle className={cn('size-4 shrink-0 animate-spin', className)} aria-hidden="true" />
  );
}

export function LoadingStatus({ label, className }: { label: string; className?: string }) {
  return (
    <div role="status" className={cn('text-fg-muted flex items-center gap-2.5 text-sm', className)}>
      <Spinner />
      <span>{label}</span>
    </div>
  );
}

export function FullPageSpinner({ label = 'Loading Mio…' }: { label?: string }) {
  return (
    <div className="bg-sidebar flex min-h-dvh items-center justify-center p-6">
      <div className="bg-canvas border-line rounded-xl border px-8 py-7 shadow-sm">
        <LoadingStatus label={label} />
      </div>
    </div>
  );
}
